var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13148 3.86609C4.77992 3.51453 4.20898 3.51453 3.85742 3.86609C3.50586 4.21766 3.50586 4.78859 3.85742 5.14016L7.7218 9.00172L3.86023 12.8661C3.50867 13.2177 3.50867 13.7886 3.86023 14.1402C4.2118 14.4917 4.78273 14.4917 5.1343 14.1402L8.99586 10.2758L12.8602 14.1373C13.2118 14.4889 13.7827 14.4889 14.1343 14.1373C14.4859 13.7858 14.4859 13.2148 14.1343 12.8633L10.2699 9.00172L14.1315 5.13734C14.483 4.78578 14.483 4.21484 14.1315 3.86328C13.7799 3.51172 13.209 3.51172 12.8574 3.86328L8.99586 7.72766L5.13148 3.86609Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c64c8e31c5ae4804c36c2e6507a32fda.svg";
export { ForwardRef as ReactComponent };